import React, { useState, useEffect } from 'react';
import { getWaTemplates, createWaTemplate, deleteWaTemplate } from '../api';
import TagsInput from '../components/TagsInput';
import toast from 'react-hot-toast';
import { MessageSquare, Plus, Trash2, X, Eye } from 'lucide-react';

export default function WaTemplates() {
  const [templates, setTemplates] = useState([]);
  const [show, setShow] = useState(false);
  const [preview, setPreview] = useState(null);
  const [f, setF] = useState({ name:'', metaTemplateName:'', language:'en', body:'', headerType:'none', headerContent:'', footer:'', buttons:[], tags:[] });

  useEffect(() => { load(); }, []);
  const load = async () => { try { setTemplates((await getWaTemplates()).data); } catch(e){} };

  const handleCreate = async () => {
    if (!f.name || !f.body) return toast.error('Name and body are required');
    try {
      await createWaTemplate(f);
      toast.success('Template created!');
      setShow(false); setF({ name:'',metaTemplateName:'',language:'en',body:'',headerType:'none',headerContent:'',footer:'',buttons:[],tags:[] }); load();
    } catch(e) { toast.error(e.response?.data?.error||'Failed'); }
  };

  const addButton = () => {
    if (f.buttons.length >= 3) return;
    setF({...f, buttons:[...f.buttons, {type:'quick_reply',text:'',value:''}]});
  };

  return (<>
    <div className="pg-hdr">
      <h2>WhatsApp Templates</h2>
      <p>Create message templates. Use {'{{name}}'}, {'{{company}}'}, {'{{phone}}'} variables. For Meta API, use approved template names.</p>
      <div className="pg-acts"><button className="btn btn-p" onClick={()=>setShow(true)}><Plus size={15}/> New Template</button></div>
    </div>
    <div className="pg-body">
      {templates.length===0 ? <div className="card"><div className="empty"><MessageSquare size={44}/><h3>No WhatsApp templates</h3><p>Create your first message template</p></div></div> :
      templates.map(t=><div key={t._id} className="card" style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
        <div style={{flex:1}}>
          <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:3,flexWrap:'wrap'}}>
            <span style={{fontWeight:600,fontSize:13.5}}>{t.name}</span>
            {t.metaTemplateName&&<span className="badge b-delivered">{t.metaTemplateName}</span>}
            {(t.tags||[]).map((tg,i)=><span className="tag" key={i}>{tg}</span>)}
          </div>
          <div style={{fontSize:12,color:'var(--txt2)',whiteSpace:'pre-wrap',maxHeight:60,overflow:'hidden'}}>{t.body}</div>
          {t.footer&&<div style={{fontSize:10.5,color:'var(--txtm)',marginTop:3}}>Footer: {t.footer}</div>}
          {t.buttons?.length>0&&<div style={{fontSize:10.5,color:'var(--txtm)',marginTop:2}}>Buttons: {t.buttons.map(b=>b.text).join(', ')}</div>}
        </div>
        <div style={{display:'flex',gap:4}}>
          <button className="btn btn-g btn-sm" onClick={()=>setPreview(t)}>Preview</button>
          <button className="btn btn-d btn-sm" onClick={async()=>{await deleteWaTemplate(t._id);toast.success('Deleted');load();}}>Delete</button>
        </div>
      </div>)}
    </div>

    {show&&<div className="modal-bg" onClick={()=>setShow(false)}><div className="modal modal-lg" onClick={e=>e.stopPropagation()}>
      <div className="modal-hdr"><h3>Create WhatsApp Template</h3><button className="btn btn-g btn-sm" onClick={()=>setShow(false)}><X size={15}/></button></div>
      <div className="modal-body">
        <div className="fr2">
          <div className="fg"><label className="lbl">Template Name *</label><input className="inp" value={f.name} onChange={e=>setF({...f,name:e.target.value})} placeholder="Welcome Message"/></div>
          <div className="fg"><label className="lbl">Meta Template Name (if approved)</label><input className="inp" value={f.metaTemplateName} onChange={e=>setF({...f,metaTemplateName:e.target.value})} placeholder="hello_world"/><div style={{fontSize:10,color:'var(--txtm)',marginTop:3}}>Leave blank for session text messages</div></div>
        </div>
        <div className="fg">
          <label className="lbl">Message Body *</label>
          <textarea className="inp tarea" value={f.body} onChange={e=>setF({...f,body:e.target.value})} style={{minHeight:120}}
            placeholder={"Hi {{name}}! 👋\n\nThanks for your interest in our services at {{company}}.\n\nWould you like to schedule a call?\n\nBest regards"}/>
          <div style={{fontSize:10,color:'var(--txtm)',marginTop:3}}>Variables: {'{{name}}'}, {'{{company}}'}, {'{{phone}}'}</div>
        </div>
        <div className="fr2">
          <div className="fg"><label className="lbl">Header Type</label>
            <select className="inp sel" value={f.headerType} onChange={e=>setF({...f,headerType:e.target.value})}>
              <option value="none">None</option><option value="text">Text</option><option value="image">Image URL</option>
            </select>
          </div>
          {f.headerType!=='none'&&<div className="fg"><label className="lbl">Header Content</label><input className="inp" value={f.headerContent} onChange={e=>setF({...f,headerContent:e.target.value})} placeholder={f.headerType==='image'?'https://...':'Header text'}/></div>}
        </div>
        <div className="fg"><label className="lbl">Footer (optional)</label><input className="inp" value={f.footer} onChange={e=>setF({...f,footer:e.target.value})} placeholder="Reply STOP to unsubscribe"/></div>
        <div className="fg">
          <label className="lbl">Quick Reply Buttons (max 3)</label>
          {f.buttons.map((b,i)=><div key={i} style={{display:'flex',gap:8,marginBottom:6,alignItems:'center'}}>
            <input className="inp" value={b.text} onChange={e=>{const btns=[...f.buttons];btns[i].text=e.target.value;setF({...f,buttons:btns});}} placeholder="Button text" style={{flex:1}}/>
            <button className="btn btn-d btn-sm" onClick={()=>setF({...f,buttons:f.buttons.filter((_,j)=>j!==i)})}>✕</button>
          </div>)}
          {f.buttons.length<3&&<button className="btn btn-g btn-sm" onClick={addButton}>+ Add Button</button>}
        </div>
        <div className="fg"><label className="lbl">Tags</label><TagsInput tags={f.tags} onChange={tags=>setF({...f,tags})}/></div>
      </div>
      <div className="modal-ft">
        <button className="btn btn-s" onClick={()=>setShow(false)}>Cancel</button>
        <button className="btn btn-p" onClick={handleCreate}><Plus size={15}/> Create Template</button>
      </div>
    </div></div>}

    {preview&&<div className="modal-bg" onClick={()=>setPreview(null)}><div className="modal" onClick={e=>e.stopPropagation()}>
      <div className="modal-hdr"><h3>Preview: {preview.name}</h3><button className="btn btn-g btn-sm" onClick={()=>setPreview(null)}><X size={15}/></button></div>
      <div className="modal-body">
        {/* WhatsApp-style preview */}
        <div style={{background:'#e5ddd5',borderRadius:10,padding:20,maxWidth:360,margin:'0 auto'}}>
          {preview.headerType==='text'&&<div style={{fontWeight:700,fontSize:14,marginBottom:6}}>{preview.headerContent}</div>}
          {preview.headerType==='image'&&<div style={{background:'#ccc',height:120,borderRadius:8,marginBottom:8,display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,color:'#666'}}>📷 Image</div>}
          <div style={{background:'#dcf8c6',borderRadius:'8px 8px 8px 0',padding:'8px 12px',fontSize:13.5,lineHeight:1.6,whiteSpace:'pre-wrap',boxShadow:'0 1px 2px rgba(0,0,0,.1)'}}>
            {preview.body}
            {preview.footer&&<div style={{fontSize:11,color:'#8696a0',marginTop:6,borderTop:'1px solid rgba(0,0,0,.05)',paddingTop:4}}>{preview.footer}</div>}
            <div style={{fontSize:10,color:'#8696a0',textAlign:'right',marginTop:4}}>{new Date().toLocaleTimeString([], {hour:'2-digit',minute:'2-digit'})} ✓✓</div>
          </div>
          {preview.buttons?.length>0&&<div style={{marginTop:6,display:'flex',flexDirection:'column',gap:4}}>
            {preview.buttons.map((b,i)=><div key={i} style={{background:'#fff',borderRadius:8,padding:'8px 12px',textAlign:'center',fontSize:13,color:'#00a884',fontWeight:500,boxShadow:'0 1px 2px rgba(0,0,0,.1)'}}>{b.text}</div>)}
          </div>}
        </div>
      </div>
    </div></div>}
  </>);
}
